import { Dispatch, FC, SetStateAction } from "react";
import { IInputComponentProps, Input } from "../../Elements/Input";
import { useTranslation } from "react-i18next";
import { TextInput } from "@inceptionbg/ui-components";
import { Dialog } from "../../Elements/Dialog";
import { IFieldBook } from "../../types/IFieldBook";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  data?: Partial<IFieldBook>;
  setData: Dispatch<SetStateAction<Partial<IFieldBook>>>;
  onSubmit: () => void;
}
export const FieldBookDialog: FC<Props> = ({
  isOpen,
  onClose,
  data,
  setData,
  onSubmit,
}) => {
  const { t } = useTranslation();

  const formInfo: IInputComponentProps[] = [
    {
      label: t("Name"),
      input: (
        <TextInput
          value={data?.name || ""}
          setValue={(e) => setData({ ...data, name: e })}
          // disabled={true}
        />
      ),
    },
  ];

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={t("AddField")}
      confirmButton={{
        onFormSubmit: onSubmit,
        label: t("Confirm"),
      }}
      cancelButton={{ onClick: onClose }}
      size="m"
    >
      <div className="flex column gap-4">
        {formInfo.map((e) => (
          <Input key={e.label} component={e} edit />
        ))}
      </div>
    </Dialog>
  );
};
